import { ToDoPageSize } from '@opsbase/lib-data-query/consts';
import { default as QueryFieldKey } from '@opsbase/lib-data-queryfield/QueryFieldKey';
import DataType from '@opsbase/lib-datatype/DataType';
import i18n from '@opsbase/lib-i18n';
import opIs from '@opsbase/lib-op/helpers/opIs';
import Pages from '@opsbase/lib-pages';
import App from '@opsbase/lib-system/App/App';
import { FeatureSets } from '@opsbase/lib-system/Features/Features';
import FeatureStatus from '@opsbase/lib-system/FeatureStatus/FeatureStatus';
import useSelf from '@opsbase/react-ctrl-self/useSelf';
import AppPage from '@opsbase/web-app/AppPage';
import ButtonCard from '@opsbase/web-cards/ButtonCard';
import DataTreeController from '@opsbase/web-ctrl-datatree/DataTreeController';
import useView from '@opsbase/web-ctrl-view/useView';
import useViewActions from '@opsbase/web-ctrl-view/useViewActions';
import DVLCardStack from '@opsbase/web-dvl-cardstack';
import DVLTable from '@opsbase/web-dvl-table';
import DVLToolbar from '@opsbase/web-dvl-toolbar';
import AddIcon from '@opsbase/web-icons/icons/AddIcon';
import ListRoundedIcon from '@opsbase/web-icons/icons/ListRoundedIcon';
import ViewCardsIcon from '@opsbase/web-icons/icons/ViewCardsIcon';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import useNav from '@opsbase/web-nav/useNav';
import ActionButton from '@opsbase/web-ui/ActionButton';
import Fab from '@opsbase/web-ui/Fab';
import React, { useCallback, useMemo, useState } from 'react';
import OpToDoCard from '../cards/OpToDoCard';
import OnboardingDialog from '../dialogs/onboarding/onboarding.dialog';
export function OpsToDoPage() {
    const { goTo } = useNav();
    const self = useSelf();
    const { filters } = useView(DataType.OP_TODO);
    const { setBooleanFilter } = useViewActions(DataType.OP_TODO);
    const [tableView, setTableView] = useState(false);
    const isShowingMineOnly = !!filters.find(f => f.queryFieldKey === QueryFieldKey.SHOW_MINE_ONLY && f.id === 'TRUE');
    const handleClickCreate = useCallback(() => {
        goTo(Pages.OPS_CREATE);
    }, [goTo]);
    const handleClickShowMineOnly = useCallback(() => {
        setBooleanFilter(QueryFieldKey.SHOW_MINE_ONLY, !isShowingMineOnly);
    }, [isShowingMineOnly, setBooleanFilter]);
    const handleToggleTableView = useCallback(() => setTableView(!tableView), [tableView]);
    const additionalMoreButtons = useMemo(() => {
        if (self.isEmployee || self.isTeamboard)
            return [];
        const v = [];
        if (!(self.isEmployee || self.isTeamboard)) {
            v.push(React.createElement(ActionButton, { key: "yourOps", big: true, highlight: isShowingMineOnly, onClick: handleClickShowMineOnly, label: i18n.t('your-ops') }));
        }
        v.push(React.createElement(ActionButton, { key: "showTable", disabled: tableView, highlight: tableView, onClick: handleToggleTableView, Icon: ListRoundedIcon, label: 'Table' }));
        v.push(React.createElement(ActionButton, { key: "showCards", disabled: !tableView, highlight: !tableView, onClick: handleToggleTableView, Icon: ViewCardsIcon, label: 'Cards' }));
        return v;
    }, [self, tableView, handleToggleTableView, isShowingMineOnly, handleClickShowMineOnly]);
    const getItemPage = useMemo(() => op => {
        if (opIs.performable(op))
            return Pages.OP_PERFORM;
        return Pages.OP_VIEW;
    }, []);
    return (React.createElement(AppPage, null,
        React.createElement(DataTreeController, { pageSize: ToDoPageSize, viewId: DataType.OP_TODO },
            React.createElement(Vertical, { gutter: true, style: { overflow: 'hidden' } },
                React.createElement(Pane, { padding: true },
                    React.createElement(DVLToolbar, { disableFieldSelection: true, additionalMoreButtons: additionalMoreButtons })),
                !tableView && (React.createElement(DVLCardStack, { beforeComponent: React.createElement(ButtonCard, { icon: React.createElement(AddIcon, { size: 80 }), label: i18n.t('start-an-op'), onClick: handleClickCreate }), itemComponent: OpToDoCard, notFoundText: i18n.t('todo-empty') })),
                tableView && (React.createElement(Pane, { grow: true, padding: true },
                    React.createElement(DVLTable, { selectable: false, itemPage: getItemPage, notFoundText: i18n.t('no-ops-found') }),
                    React.createElement(Fab, { onClick: handleClickCreate }))),
                !!self.organisationId &&
                    !self.isOrgSetup &&
                    self.features.some(f => f.name === FeatureSets[App.OPSBASE].ONBOARDING_WIZARD.key &&
                        f.state === FeatureStatus.ENABLED) && React.createElement(OnboardingDialog, null)))));
}
export default OpsToDoPage;
